import React from 'react';
import WebDashboard from '../WebDashboard';

const TemplateDashboardViewport = ({
    dashboardViewportRef,
    edit,
    details,
    setDetails,
    currentDashboard,
    dashboardMaxHeight,
    handleFixedWidthStateChange,
    registerFixedWidthToggleHandler,
    handleMultiSelectStateChange,
    registerMultiSelectToggleHandler,
}) => (
    <div ref={dashboardViewportRef} className="td-dashboard-viewport">
        <WebDashboard
            mode={edit.mode}
            datastreams={details.datastreams?.filter((ds) => ds)}
            setDatastreams={(newDatastreams) => setDetails((prev) => ({
                ...prev,
                datastreams: newDatastreams,
            }))}
            maxWidth="100%"
            maxHeight={dashboardMaxHeight}
            externalFixedWidthControl={edit.mode === 'edit'}
            onFixedWidthModeChange={handleFixedWidthStateChange}
            onFixedWidthToggleHandlerReady={registerFixedWidthToggleHandler}
            externalMultiSelectControl={edit.mode === 'edit'}
            onMultiSelectStateChange={handleMultiSelectStateChange}
            onMultiSelectToggleHandlerReady={registerMultiSelectToggleHandler}
            dashboard={details.webdashboard[currentDashboard]}
            setDashboard={(webDashboard) => {
                setDetails((prevDetails) => {
                    const updatedWebdashboards = [...(prevDetails.webdashboard || [])];
                    if (updatedWebdashboards[currentDashboard]) {
                        updatedWebdashboards[currentDashboard] = webDashboard;
                    }
                    return {
                        ...prevDetails,
                        webdashboard: updatedWebdashboards,
                    };
                });
            }}
        />
    </div>
);

export default TemplateDashboardViewport;
